import React from 'react'
import PropTypes from 'prop-types'
import { generatePath, useNavigate, useParams } from 'react-router-dom'

import Tabs from '~/components/Tabs'
import { ADJUSTMENT_DETAIL_PATH } from '~/constants/routes'
import { ADJUSTMENT_DETAIL_TABS } from '~/constants/tabs'

function AdjustmentDetailTabs ({ value }) {
  const navigate = useNavigate()
  const { id } = useParams()
  const onChange = (event, tab) => {
    const redirect = generatePath(ADJUSTMENT_DETAIL_PATH, { id, tab })

    navigate(redirect, { replace: true })
  }

  const tabs = [
    { value: ADJUSTMENT_DETAIL_TABS.GENERAL, label: 'General' },
    { value: ADJUSTMENT_DETAIL_TABS.HISTORY, label: `History` }
  ]

  return (
    <Tabs
      tabs={tabs}
      value={value}
      onChange={onChange}
    />
  )
}

AdjustmentDetailTabs.propTypes = {
  value: PropTypes.string.isRequired
}

export default AdjustmentDetailTabs
